var _templateObject;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import styled from 'styled-components';
export var StyledCardContent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 10px;\n"])));